var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', [_c('div', {
    staticClass: "page"
  }, [_c('div', {
    staticClass: "overflow-x-hidden mb-3"
  }, [_c('b-card', {
    staticClass: "border border-1 reward-card",
    attrs: {
      "no-body": ""
    }
  }, [_c('div', {
    staticClass: "\n            reward-card__header\n            px-3\n            d-flex\n            justify-content-between\n            align-items-center\n          "
  }, [_c('div', {
    staticClass: "reward-card__title"
  }, [_vm._v(_vm._s(_vm.card.name))]), _c('div', {
    staticClass: "d-flex align-items-center"
  }, [_c('span', {
    staticClass: "reward-card__header__point"
  }, [_vm._v(_vm._s(_vm.card.point))]), _c('span', {
    staticClass: "small ml-2"
  }, [_vm._v("點")])])]), _c('div', {
    staticClass: "reward-card__body p-4"
  }, _vm._l(5, function (i) {
    return _c('div', {
      key: i,
      staticClass: "reward-card__body__point",
      class: i <= _vm.card.point ? 'active' : ''
    }, [_c('div', {
      staticClass: "\n                reward-card__body__point__stamp\n                d-flex\n                justify-content-center\n                align-items-center\n              "
    }, [i <= _vm.card.point ? _c('img', {
      staticClass: "img-fluid",
      attrs: {
        "src": require("./images/stamp.svg")
      }
    }) : _c('span', [_vm._v(_vm._s(i))])]), _c('div', {
      staticClass: "reward-card__body__point__date"
    }, [_vm._v("08/09")])]);
  }), 0)])], 1), _c('div', {
    staticClass: "reward-card-list"
  }, [_c('div', {
    staticClass: "reward-card-list__item"
  }, [_c('div', [_c('div', {
    staticClass: "reward-card-list__image"
  }, [_c('img', {
    attrs: {
      "src": _vm.card.image || './product-image.png'
    }
  })]), _c('div', {
    staticClass: "reward-card-list__stamp"
  }, _vm._l(4, function (i) {
    return _c('i', {
      key: i,
      staticClass: "fa fa-star",
      class: _vm.card.point >= i && 'active',
      attrs: {
        "aria-hidden": "true"
      }
    });
  }), 0)]), _c('div', {
    staticClass: "reward-card-list__content"
  }, [_c('div', {
    staticClass: "reward-card-list__title"
  }, [_vm._v(_vm._s(_vm.card.name))]), _c('div', {
    staticClass: "reward-card-list__date"
  }, [_vm._v(" 開始日期" + _vm._s(_vm.card.startAt || "") + " ")]), _c('div', {
    staticClass: "reward-card-list__date"
  }, [_vm._v(" 到期日期" + _vm._s(_vm.card.endAt || "") + " ")])])])]), _c('SharedButton', {
    staticClass: "s-btn-bg-primary",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function click($event) {
        return _vm.$router.push({
          name: 'LiffRewardsCardReceiver'
        });
      }
    }
  }, [_vm._v(" 前往兌換贈品 ")]), _c('div', {
    staticClass: "reward-award mt-3"
  }, [_c('div', {
    staticClass: "reward-award__title"
  }, [_vm._v("點數獎項")]), _vm._l(_vm.awards, function (i) {
    return _c('b-card', {
      key: i.id,
      staticClass: "reward-award-item d-flex flex-nowrap flex-row mt-3",
      attrs: {
        "no-body": ""
      }
    }, [_c('div', {
      staticClass: "reward-award-item__image"
    }, [_c('img', {
      staticClass: "img-fluid",
      attrs: {
        "src": "https://picsum.photos/300?img=".concat(i.point)
      }
    })]), _c('div', {
      staticClass: "flex-fill p-2 d-flex flex-column"
    }, [_c('div', {
      staticClass: "reward-award-item__title flex-fill"
    }, [_vm._v(_vm._s(i.name))])])]);
  })], 2)], 1), _vm._m(0)]);
}
var staticRenderFns = [function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "reward-notice s-p-3"
  }, [_c('div', {
    staticClass: "reward-notice__title"
  }, [_vm._v("注意事項")]), _c('ol', [_c('li', [_vm._v(" 若您於4/20前至直營門市消費，尚未升級會員等級，請主動與門市人員聯絡，由門市人員協助處理。 ")]), _c('li', [_vm._v(" 每位會員每場體驗活動僅限報名一次無法重複報名。會員已詳讀並同意注意事項。 ")]), _c('li', [_vm._v(" 填寫報名資料請務必確認您的資訊是否正確，以便錄取後通知．送出後不得進行任何資料更改；請注意有無開啟阻擋廣告功能。 ")])])]);
}]

export { render, staticRenderFns }